import React from "react";
import produce from "immer";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";

import { resourceCentreActions } from "../../../../actions";
import DiscountSetting from "../../ClinicSettings/DiscountSettings";
import ProductCategoryAddition from "../../ProductCategoryAddition";
import useCurrentResourceCentre from "../../../../hooks/useCurrentResourceCentre";

// eslint-disable-next-line import/prefer-default-export
export function StockSettings(): React.ReactNode {
  const dispatch = useDispatch();
  const resourceCentre = useCurrentResourceCentre();

  return (
    <Box>
      <DiscountSetting
        discountSettings={resourceCentre.settings.stockSettings.discountSettings}
        onChange={(discountSettings) => {
          const newRc = produce(resourceCentre, (draft) => {
            draft.settings.stockSettings.discountSettings = discountSettings;
          });
          dispatch(resourceCentreActions.putResourceCentre(newRc));
        }}
      />

      <ProductCategoryAddition resourceCentre={resourceCentre} />
    </Box>
  );
}
